import axios from 'axios';
import { createCloseDayQuery } from './queries';
import moment from 'moment-timezone';

const putCloseDayDetails = async (date, is_locked) => {
    const query = createCloseDayQuery({ date, is_locked });
    const response = await axios.put(query.url, { ...query.body });
    return { data: response.data };
};

export default putCloseDayDetails;
